import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'

/**
 * For more information go to
 * http://izitoast.marcelodolce.com/#Options
 */

const CONSTANTS = {
  POSITIONS: {
    BOTTOM_RIGHT: 'bottomRight',
    BOTTOM_LEFT: 'bottomLeft',
    BOTTOM_CENTER: 'bottomCenter',
    TOP_RIGHT: 'topRight',
    TOP_LEFT: 'topLeft',
    TOP_CENTER: 'topCenter',
    CENTER: 'center'
  },
  THEME: {
    LIGHT: 'light',
    DARK: 'dark'
  },
  color: {
    BLUE: 'blue',
    RED: 'red',
    GREEN: 'green',
    YELLOW: 'yellow'
  },
  TYPE: {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    INFO: 'info'
  }
}

class Toast {
  constructor (setupOptions) {
    this.setupOptions = setupOptions
  }

  /**
   * The normal options are the following
   * @param {title, message} normalOptions
   */
  success (options) {
    iziToast.success({...this.setupOptions, ...options})
  }

  warning (options) {
    iziToast.warning({...this.setupOptions, ...options})
  }

  error (options) {
    iziToast.error({...this.setupOptions, ...options})
  }

  info (options) {
    iziToast.info({...this.setupOptions, ...options})
  }

  destroy () {
    iziToast.destroy()
  }
}

export {
  CONSTANTS,
  Toast
}

/**
 * {
    id: null,
    class: '',
    title: '',
    titleColor: '',
    titleSize: '',
    titleLineHeight: '',
    message: '',
    messageColor: '',
    messageSize: '',
    messageLineHeight: '',
    backgroundColor: '',
    theme: 'light', // dark
    color: '', // blue, red, green, yellow
    icon: '',
    iconText: '',
    iconColor: '',
    iconUrl: null,
    image: '',
    imageWidth: 50,
    maxWidth: null,
    zindex: null,
    layout: 1,
    balloon: false,
    close: true,
    closeOnEscape: false,
    closeOnClick: false,
    displayMode: 0, // once, replace
    position: 'bottomRight', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
    target: '',
    targetFirst: true,
    timeout: 5000,
    rtl: false,
    animateInside: true,
    drag: true,
    pauseOnHover: true,
    resetOnHover: false,
    progressBar: true,
    progressBarColor: '',
    progressBarEasing: 'linear',
    overlay: false,
    overlayClose: false,
    overlayColor: 'rgba(0, 0, 0, 0.6)',
    transitionIn: 'fadeInUp',
    transitionOut: 'fadeOut',
    transitionInMobile: 'fadeInUp',
    transitionOutMobile: 'fadeOutDown',
    buttons: {},
    inputs: {},
    onOpening: function () {},
    onOpened: function () {},
    onClosing: function () {},
    onClosed: function () {}
}
 */



// WEBPACK FOOTER //
// ./src/app/components/common/toasts/Toast.js